import { useMemo } from 'react';

import { AUTH_STRATEGY, ERROR_TYPES } from '@dashboard/library';
import { GetSignInStrategyQuery } from '@generated/GetSignInStrategyQuery';
import { GET_SIGN_IN_STRATEGY_QUERY } from '@graphql/queries/GetSignInStrategyQuery';
import { useGraphQuery } from '@hooks/useQuery';

/**
 * Hook to handle the authentication strategy.
 * @returns object holding the current strategy and setters to change it.
 */
export function useAuthStrategy() {
  const {
    data: strategyData,
    loading,
    error: strategyError,
  } = useGraphQuery<GetSignInStrategyQuery>(GET_SIGN_IN_STRATEGY_QUERY, {
    throwError: false,
  });

  let strategies: AUTH_STRATEGY[] = [AUTH_STRATEGY.PASSWORD];

  if (strategyError?.type === ERROR_TYPES.NOT_FOUND) {
    // The strategy request can respond with a 404, it means that the strategy is password
    strategies = [AUTH_STRATEGY.PASSWORD];
  } else if (strategyData?.getSignInStrategy?.strategies?.length) {
    strategies = strategyData.getSignInStrategy.strategies as AUTH_STRATEGY[];
  }

  const privilegedUserIds = useMemo(
    () => strategyData?.getSignInStrategy?.privilegedUserIds || [],
    [strategyData]
  );

  return {
    strategies,
    privilegedUserIds,
    loading,
  };
}
